import React from "react";
import { Trans } from "@lingui/macro";
import ProductsFilter from "../../../components/ProductsFilter";
import ProductsGridAdapter from "../../../components/ProductsGrid/ProductsGridAdapter";

const ProductsSection = ({
  isMobile,
  dispatch,
  attraction,
  lang,
  defaultProductsGridProps,
  products,
  cityId,
  currency,
  attractionId,
  filters,
}) => {
  return (
    <div>
      <div className="attraction-page-wrapper__products-filter_title">
        <Trans>All self-guided activities</Trans>
      </div>
      <ProductsFilter
        isMobile={isMobile}
        isDesktop={!isMobile}
        dispatch={dispatch}
        attraction={attraction}
        lang={lang}
      />

      <ProductsGridAdapter
        {...defaultProductsGridProps}
        products={products.prefetched.products}
        queryData={{
          loading: products.loading,
          current: products.current,
          next: products.next,
          count: products.count,
          pages: products.pages,
        }}
        selectParams={{
          cityId,
          currency,
          attractionId,
          ...filters,
          lang: filters?.lang?.length ? filters.lang : lang,
          separateTo: "mainProducts",
        }}
        showMorePaginate={!isMobile}
        limitDisplay={false}
      />
    </div>
  );
};

export default ProductsSection;
